var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtl24HRoomServiceFilled = function SvgHtl24HRoomServiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "htl24hRoomServiceFilled_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v15.995h16V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#htl24hRoomServiceFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 13.002a2 2 0 0 1-2-2h14a2 2 0 0 1-2 2H3Zm9.375-3.5a4.14 4.14 0 0 0-4.376-4.077 4.14 4.14 0 0 0-4.375 4.077.5.5 0 0 1-1 0 4.907 4.907 0 0 1 1.59-3.667 5.565 5.565 0 0 1 3.785-1.41 5.568 5.568 0 0 1 3.785 1.41 4.907 4.907 0 0 1 1.59 3.667.5.5 0 0 1-.999 0Zm-4.972-5.5a.406.406 0 0 1-.4-.4v-.193a.406.406 0 0 1 .4-.4h1.193a.406.406 0 0 1 .4.4v.193a.406.406 0 0 1-.4.4H7.403Z"
  }))));
};
export default SvgHtl24HRoomServiceFilled;